import * as React from "react";

import Modal, { ModalSize } from "../../../../misc/components/modal";
import { EnterNewSubjectId } from "./EnterNewSubjectId";
import { WizardActionTypes, WizardState } from '../WizardTypings';
import { useWizard } from '../../../Hooks/UseWizard';
import { VisibleWizards, Correction } from '../../../Request/DcfRequestReducer';
import { CorrectionPreviewModal } from '../../CorrectionPreviewModal';
import { CorrectionTypesEnum } from "../../../../misc/api/apiTypes";

export interface SubjectIdCorrectionWizardProps {
    isVisible: boolean;
    onClose: () => void;
    originalSubjectId: string;
    siteNumber: string;
    onComplete: (corrections: Correction[]) => void;
    subjectIdFieldDisplayText: string;
    correctedSubjectId: string;
}

export const SubjectIdCorrectionWizard = ({ isVisible, onClose, originalSubjectId, onComplete, siteNumber, subjectIdFieldDisplayText, correctedSubjectId }: SubjectIdCorrectionWizardProps): JSX.Element => {
    const { currentState, dispatch } = useWizard();
    const [newSubjectId, setNewSubjectId] = React.useState(correctedSubjectId || originalSubjectId);

    if (!isVisible) {
        return null;
    }

    let page = null;
    switch (currentState.page) {
        case 0:
            page = (
                <EnterNewSubjectId onNext={(value) => {
                    setNewSubjectId(value);
                    dispatch(WizardActionTypes.Next);
                }}
                    originalSubjectId={originalSubjectId}
                    correctedSubjectId={newSubjectId}
                    siteNumber={siteNumber} />
            );
            break;
        case 1:
            const corrections = [{
                sourceCorrection: VisibleWizards.SubjectNumber,
                correctionTypeId: CorrectionTypesEnum.SubjectNumber,
                entity: "Subject",
                field: "SubjectNumber",
                oldValue: originalSubjectId,
                newValue: newSubjectId
            }];
            page = (
                <CorrectionPreviewModal
                    corrections={corrections}
                    miscCorrection={null}
                    onNext={() => onComplete(corrections)}
                    onPrev={() => dispatch(WizardActionTypes.Previous)}
                />
            );
            break;
        default:
            page = null;
    }

    return (
        <Modal show={true} header="Change Subject ID" size={ModalSize.Large} closeModalHandler={onClose}>
            {page}
        </Modal>
    );
};
